// extracted by mini-css-extract-plugin
export default {"svgContainer":"styles_svg-container_oXpc6","svg":"styles_svg_Tszrw"};